import React from 'react';
import { useHits } from 'react-instantsearch';

export default function PlannerHits() {
    const { hits } = useHits();

    if (hits.length === 0) return null;

    return (
        <div className="col-12">
            <p className="font-weight-bold mb-6">{window.Translator.trans('app.header.search.results.planners')}</p>
            <div className="row row--equalized row--equalized gutters-4">
                {hits.map((planner, index) => (
                    <div key={index} className="col-4 col-md-3 col-lg-2">
                        <a className="text-decoration-none" href={planner?.url}>
                            <div className="card bg-white h-100">
                                <div className="card-body p-3 p-lg-6">
                                    <div className="d-flex flex-column h-100 gap-5">
                                        <img className="m-auto img-fluid search-brand-logo"
                                             src={planner?.image_url} width="60" alt={planner?.brand}/>
                                        <p className="text-center text--14 mt-auto">{planner?.brand}</p>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
}
